import { FormattedMessage } from 'react-intl';

import { useProject } from '~/hooks/api/useProject';
import Inset from '~/modules/ui-kit/spacings/inset';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material';

import ContentView from '~/components/ContentView';
import MarkdownToJsx from '~/components/MarkdownToJsx';
import DrawerButton from '../DrawerButton';
import messages from './messages';

export const Contact = () => {
  const theme = useTheme();
  const { data: project, isLoading } = useProject();

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <DrawerButton />
            <Typography variant="h6" style={{ marginLeft: theme.spacing(2) }}>
              <FormattedMessage {...messages.title} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
      isLoading={isLoading}
    >
      <Inset>
        <Typography variant="h5" gutterBottom>
          {project ? project.name : ''}
        </Typography>
      </Inset>
      <Inset>
        {!isLoading && (
          <MarkdownToJsx>
            {project?.contactInfo ? project.contactInfo : ''}
          </MarkdownToJsx>
        )}
      </Inset>
    </ContentView>
  );
};

export default Contact;
